import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles6';

function Pagina6({ data }) {

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div class="text">
            <p class="titulo">Proposta</p>
            <p class="sub-titulo">CONDIÇÕES GERAIS</p>
          </div>
          <div class="escopo">
            <div className="item">
              <pre class="descricao">{data?.condicoesGerais}</pre>
            </div>
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina6;